
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/case-studies/[slug]",
      function () {
        return require("private-next-pages/living/case-studies/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/case-studies/[slug]"])
      });
    }
  